// Shared API base URL utility
// Uses relative /api path on custom domains (same-origin), absolute URL for preview
const API = (() => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  if (typeof window !== 'undefined' && backendUrl) {
    try {
      const backendHost = new URL(backendUrl).hostname;
      const currentHost = window.location.hostname;
      if (currentHost !== backendHost && !currentHost.includes('localhost')) {
        return '/api';
      }
    } catch (e) { /* fallback */ }
  }
  return backendUrl ? `${backendUrl}/api` : '/api';
})();

export default API;
